<ng-container *transloco="let t">
  <div class="d-flex" [ngClass]="{'pt-2': !isXsComponent}">
    <div [ngClass]="{'me-2 favorite-event-indicator': isXsComponent}">
      <app-favorite-event-indicator [isXsComponent]="isXsComponent" [eventItem]="this.event"
                                    [isPreviewComponent]="isPreviewComponent" [asButton]="false"/>
    </div>
    @if (isXsComponent) {
      <div class="favorite-event-indicator" (click)="openShareModal()">
        <img src="assets/icons/icons-alt/share-alt.svg" alt="{{t('app.common.share')}}">
      </div>
    } @else {
      <div class="d-flex cursor-pointer align-items-center" (click)="openShareModal()">
        <span class="text-uppercase fs-14 pe-1">{{t('app.common.share')}}</span>
        <img src="assets/icons/icons-alt/share-alt.svg" alt="{{t('app.common.share')}}">
      </div>
    }
  </div>
</ng-container>
